/*
 * Datazoom, Inc ("COMPANY") CONFIDENTIAL
 * Copyright (c) 2017-2018 [Datazoom, Inc.], All Rights Reserved.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 */

export const types = {
  FETCH_COLLECTORS: "[Collectors] Fetch collectors",
  FETCH_COLLECTORS_SUCCESS: "[Collectors] Fetch collectors success",
  FETCH_COLLECTORS_FAILED: "[Collectors] Fetch collectors failed",
  FETCH_JAVASCRIPT_COLLECTORS: "[Collectors] Fetch javascript collectors",
  FETCH_JAVASCRIPT_COLLECTORS_SUCCESS:
    "[Collectors] Fetch javascript collectors success",
  FETCH_JAVASCRIPT_COLLECTORS_FAILED:
    "[Collectors] Fetch javascript collectors failed",

  LOAD_MORE_COLLECTORS: "[Collectors] Load More collectors",
  LOAD_MORE_COLLECTORS_SUCCESS: "[Collectors] Load More collectors success",
  LOAD_MORE_COLLECTORS_FAILED: "[Collectors] Load More collectors failed",

  CREATE_COLLECTOR: "[Collectors] Create collector",
  CREATE_COLLECTOR_SUCCESS: "[Collectors] Create collector success",
  CREATE_COLLECTOR_FAILED: "[Collectors] Create collector failed",

  FETCH_A_COLLECTOR: "[Collectors] Fetch a collector",
  FETCH_A_COLLECTOR_SUCCESS: "[Collectors] Fetch a collector success",
  FETCH_A_COLLECTOR_FAILED: "[Collectors] Fetch a collector failed",
  FORBIDDEN_COLLECTOR: "[Collectors] Forbidden",
  REMOVE_COLLECTOR: "[Collectors] Remove current collector",

  DISABLE_COLLECTOR: "[Collectors] Disable current collector",
  DISABLE_COLLECTOR_SUCCESS: "[Collectors] Disable current collector success",
  DISABLE_COLLECTOR_FAILED: "[Collectors] Disable current collector failed",

  ENABLE_COLLECTOR: "[Collectors] Enable current collector",
  ENABLE_COLLECTOR_SUCCESS: "[Collectors] Enable current collector success",
  ENABLE_COLLECTOR_FAILED: "[Collectors] Enable current collector failed",

  FETCH_COLLECTOR_OF_DATAPIPE: "[Collectors] Fetch collector of datapipe",
  FETCH_COLLECTOR_OF_DATAPIPE_SUCCESS:
    "[Collectors] Fetch collector of datapipe success",
  FETCH_COLLECTOR_OF_DATAPIPE_FAIL:
    "[Collectors] Fetch collector of datapipe fail",

  FETCH_COLLECTOR_APIKEY: "[Collector API Key ] Fetch collector API Key",
  FETCH_COLLECTOR_APIKEY_SUCCESS:
    "[Collector API Key] Fetch collector API Key success",
  FETCH_COLLECTOR_APIKEY_FAILED:
    "[Collector API Key] Fetch collector API Key failed",
  UNSET_API_KEY: "[Collector API Key] Unset collector API Key",
  REGENERATE_COLLECTOR_APIKEY:
    "[Renerate Collector API Key ] Renerate collector API Key",
  REGENERATE_COLLECTOR_APIKEY_SUCCESS:
    "[Renerate Collector API Key] Renerate collector API Key success",
  REGENERATE_COLLECTOR_APIKEY_FAILED:
    "[Renerate Collector API Key] Renerate collector API Key failed",
  // NEW
  SET_COLLECTOR_FILTER_ACTIVE_DISABLE:
    "[Collectors] Set collector Active Disable ",
  REMOVE_COLLECTOR_FILTER_ACTIVE_DISABLE:
    "[Collectors] Remove collector Active Disable ",
  // END
  FETCH_A_COLLECTOR_DEL: "[Collectors] Fetch a collector del",
  FETCH_A_COLLECTOR_DEL_SUCCESS: "[Collectors] Fetch a collector del success",
  FETCH_A_COLLECTOR_DEL_FAILED: "[Collectors] Fetch a collector del failed",
  DELETE_COLLECTOR: "[Collectors] Delete collector",
  DELETE_COLLECTOR_SUCCESS: "[Collectors] Delete collector success",
  DELETE_COLLECTOR_FAILED: "[Collectors] Delete collector failed",
  REMOVE_DEL_COLLECTOR: "[Collectors] Remove del collector",
  CLEAR_COLLECTOR: "[Collectors] Clear Collectors",
  UPDATE_COLLECTOR: "[Collectors] Update collector",
  UPDATE_COLLECTOR_SUCCESS: "[Collectors] Update collector success",
  UPDATE_COLLECTOR_FAILED: "[Collectors] Update collector failed",
  UPDATE_COLLECTOR_LIST: "[Collectors] Update collector list",
  FETCH_A_COLLECTOR_CONFIG_STATS: "[Collectors] Fetch a Collector Confi stats",
  FETCH_A_COLLECTOR_CONFIG_STATS_SUCCESS:
    "[Collectors] Fetch a Collector stats success",
  FETCH_A_COLLECTOR_CONFIG_STATS_FAILED:
    "[Collectors] Fetch a Collector Config stats failed",
  CLEAR_COLLECTOR_CONFIG_STATS: "[Collectors] Clear Collectors Config stats",
  UPDATE_LINKED_COLLECTOR: "[Collectors] Update linked collector",
  UPDATE_LINKED_COLLECTOR_SUCCESS:
    "[Collectors] Update linked collector success",
  UPDATE_LINKED_COLLECTOR_FAILED: "[Collectors] Update linked collector failed",
  FETCH_MEDIA_PLUGINS: "[Collectors] Fetch media plugins",
  FETCH_MEDIA_PLUGINS_SUCCESS: "[Collectors] Fetch media plugins success",
  FETCH_MEDIA_PLUGINS_FAILED: "[Collectors] Fetch media plugins failed",
  CLEAR_MEDIA_PLUGINS_LIST: "[Collectors] Clear media plugins list",
  CREATE_COLLECTOR_CONFIGURATION: "[Collectors] Create collector configuration",
  CREATE_COLLECTOR_CONFIGURATION_SUCCESS:
    "[Collectors] Create collector configuration success",
  CREATE_COLLECTOR_CONFIGURATION_FAILED:
    "[Collectors] Create collector configuration failed",
  CLEAR_COLLECTOR_CONFIGURATION_RESPONSE:
    "[Collectors] Create collector configuration response",
  FETCH_PLATFORMS: "[Collectors] Fetch platforms",
  FETCH_PLATFORMS_SUCCESS: "[Collectors] Fetch platforms success",
  FETCH_PLATFORMS_FAILED: "[Collectors] Fetch platforms failed",
  CLEAR_COLLECTOR_LIST: "[Collectors] Clear collector list",
  CLEAR_JAVASCRIPT_COLLECTOR_LIST:
    "[Collectors] Clear Javascript collector list",

  LOAD_MORE_JAVASCRIPT_COLLECTORS:
    "[Collectors] Load More Javascript collectors",
  LOAD_MORE_JAVASCRIPT_COLLECTORS_SUCCESS:
    "[Collectors] Load More Javascript collectors success",
  LOAD_MORE_JAVASCRIPT_COLLECTORS_FAILED:
    "[Collectors] Load More Javascript collectors failed",

  FETCH_COLLECTOR_LOGS: "[Collectors] Fetch a Collector Logs",
  FETCH_COLLECTOR_LOGS_SUCCESS: "[Collectors] Fetch a Collector Logs Success ",
  FETCH_COLLECTOR_LOGS_FAILED: "[Collectors] Fetch a Collector Logs Failed",

  FETCH_A_COLLECTOR_ADFRAMEWORK: "[Collectors] Fetch a Collector AdFramework",
  FETCH_A_COLLECTOR_ADFRAMEWORK_SUCCESS:
    "[Collectors] Fetch a Collector AdFramework Success ",
  FETCH_A_COLLECTOR_ADFRAMEWORK_FAILED:
    "[Collectors] Fetch a Collector AdFramework Failed",
};
//
// ─── FETCH COLLECTOR ACTIONS ────────────────────────────────────────────────────
//

export const FetchCollector = (
  companyId,
  status,
  page,
  size,
  order,
  query,
  field,
  projectId,
  filters,
  initial_load,
) => ({
  type: types.FETCH_COLLECTORS,
  payload: {
    companyId,
    status,
    page,
    size,
    order,
    query,
    field,
    projectId,
    filters,
    initial_load,
  },
});
export const FetchCollectorsSuccess = /* istanbul ignore next */ (list) => ({
  type: types.FETCH_COLLECTORS_SUCCESS,
  payload: list,
});
export const FetchCollectorsFailed = (error) => ({
  type: types.FETCH_COLLECTORS_FAILED,
  payload: error,
});

export const FetchJavascriptCollectors = (
  companyId,
  status,
  page,
  size,
  order,
  query,
  field,
  projectId,
  filters,
) => ({
  type: types.FETCH_JAVASCRIPT_COLLECTORS,
  payload: {
    companyId,
    status,
    page,
    size,
    order,
    query,
    field,
    projectId,
    filters,
  },
});
export const FetchJavascriptCollectorsSuccess = /* istanbul ignore next */ (
  list,
) => ({
  type: types.FETCH_JAVASCRIPT_COLLECTORS_SUCCESS,
  payload: list,
});
export const FetchJavascriptCollectorsFailed = (error) => ({
  type: types.FETCH_JAVASCRIPT_COLLECTORS_FAILED,
  payload: error,
});

//
// ─── LOAD MORE COLLECTOR ACTIONS ────────────────────────────────────────────────────
//
export const LoadMoreCollector = (
  companyId,
  status,
  page,
  size,
  order,
  query,
  field,
  projectId,
  filters,
) => ({
  type: types.LOAD_MORE_COLLECTORS,
  payload: {
    companyId,
    status,
    page,
    size,
    order,
    query,
    field,
    projectId,
    filters,
  },
});
export const LoadMoreCollectorSuccess = /* istanbul ignore next */ (list) => ({
  type: types.LOAD_MORE_COLLECTORS_SUCCESS,
  payload: list,
});
export const LoadMoreCollectorFailed = /* istanbul ignore next */ (error) => ({
  type: types.LOAD_MORE_COLLECTORS_FAILED,
  payload: error,
});

//
// ─── FETCH SINGLE COLLECTOR ACTIONS ────────────────────────────────────────────────────
//

export const FetchACollector = /* istanbul ignore next */ (id) => ({
  type: types.FETCH_A_COLLECTOR,
  payload: id,
});
export const FetchACollectorSuccess = (list) => ({
  type: types.FETCH_A_COLLECTOR_SUCCESS,
  payload: list,
});
export const FetchACollectorFailed = /* istanbul ignore next */ (error) => ({
  type: types.FETCH_A_COLLECTOR_FAILED,
  payload: error,
});
export const ForbiddenCollector = /* istanbul ignore next */ (error) => ({
  type: types.FORBIDDEN_COLLECTOR,
  payload: error,
});
//
// ─── REMOVE SINGLE COLLECTOR ACTIONS ────────────────────────────────────────────────────
//

export const RemoveCollector = /* istanbul ignore next */ (id) => ({
  type: types.REMOVE_COLLECTOR,
  payload: id,
});

//
// ─── CREATE COLLECTOR ACTIONS ────────────────────────────────────────────────────
//
export const CreateCollector = (collector) => ({
  type: types.CREATE_COLLECTOR,
  payload: collector,
});
export const CreateCollectorSuccess = (response) => ({
  type: types.CREATE_COLLECTOR_SUCCESS,
  payload: response,
});
export const CreateCollectorFailed = (error) => ({
  type: types.CREATE_COLLECTOR_FAILED,
  payload: error,
});
//
// ─── DISABLE CURRENT COLLECTOR ACTIONS ──────────────────────────────────────────
//

export const DisableCollector = (id) => ({
  type: types.DISABLE_COLLECTOR,
  payload: id,
});
export const DisableCollectorSuccess = (response) => ({
  type: types.DISABLE_COLLECTOR_SUCCESS,
  payload: response,
});
export const DisableCollectorFailed = (error) => ({
  type: types.DISABLE_COLLECTOR_FAILED,
  payload: error,
});

//
// ─── ENABLE CURRENT COLLECTOR ACTIONS ──────────────────────────────────────────
//

export const EnableCollector = (id) => ({
  type: types.ENABLE_COLLECTOR,
  payload: id,
});
export const EnableCollectorSuccess = (response) => ({
  type: types.ENABLE_COLLECTOR_SUCCESS,
  payload: response,
});
export const EnableCollectorFailed = (error) => ({
  type: types.ENABLE_COLLECTOR_FAILED,
  payload: error,
});

//
// ─── FETCH SINGLE COLLECTOR OF DATAPIPE ACTIONS ────────────────────────────────────────────────────
//

export const FetchCollectorOfDatapipe = (id) => ({
  type: types.FETCH_COLLECTOR_OF_DATAPIPE,
  payload: id,
});
export const FetchCollectorOfDatapipeSuccess = (list) => ({
  type: types.FETCH_COLLECTOR_OF_DATAPIPE_SUCCESS,
  payload: list,
});
export const FetchCollectorOfDatapipeFail = /* istanbul ignore next */ (
  error,
) => ({
  type: types.FETCH_COLLECTOR_OF_DATAPIPE_FAIL,
  payload: error,
});

//
// ─── FETCH COLLECTOR API KEY ACTIONS ──────────────────────────────────────────
//

export const FetchCollectorApiKey = (id) => ({
  type: types.FETCH_COLLECTOR_APIKEY,
  payload: id,
});
export const FetchCollectorApiKeySuccess = (response) => ({
  type: types.FETCH_COLLECTOR_APIKEY_SUCCESS,
  payload: response,
});
export const FetchCollectorApiKeyFailed = (error) => ({
  type: types.FETCH_COLLECTOR_APIKEY_FAILED,
  payload: error,
});
export const UnsetApiKey = (error) => ({
  type: types.UNSET_API_KEY,
});

//
// ─── REGENERATE COLLECTOR API KEY ACTIONS ──────────────────────────────────────────
//

export const RegenerateCollectorApiKey = (id) => ({
  type: types.REGENERATE_COLLECTOR_APIKEY,
  payload: id,
});
export const RegenerateCollectorApiKeySuccess = (response) => ({
  type: types.REGENERATE_COLLECTOR_APIKEY_SUCCESS,
  payload: response,
});
export const RegenerateCollectorApiKeyFailed = (error) => ({
  type: types.REGENERATE_COLLECTOR_APIKEY_FAILED,
  payload: error,
});
// new
export const SetCollectorFilterActiveDisable = (filter) => ({
  type: types.SET_COLLECTOR_FILTER_ACTIVE_DISABLE,
  payload: filter,
});
export const RemoveCollectorFilterActiveDisable = () => ({
  type: types.REMOVE_COLLECTOR_FILTER_ACTIVE_DISABLE,
});
// end
export const FetchACollectorDel = /* istanbul ignore next */ (id) => ({
  type: types.FETCH_A_COLLECTOR_DEL,
  payload: id,
});
export const FetchACollectorDelSuccess = (list) => ({
  type: types.FETCH_A_COLLECTOR_DEL_SUCCESS,
  payload: list,
});
export const FetchACollectorDelFailed = /* istanbul ignore next */ (error) => ({
  type: types.FETCH_A_COLLECTOR_DEL_FAILED,
  payload: error,
});
// /////////Delete Connector//////////
export const DeleteCollector = (id) => ({
  type: types.DELETE_COLLECTOR,
  payload: id,
});
export const DeleteCollectorSuccess = (response) => ({
  type: types.DELETE_COLLECTOR_SUCCESS,
  payload: response,
});
export const DeleteCollectorFailed = (response) => ({
  type: types.DELETE_COLLECTOR_FAILED,
  payload: response,
});
export const RemoveDelCollector = (id) => ({
  type: types.REMOVE_DEL_COLLECTOR,
  payload: id,
});
export const ClearCollector = () => ({
  type: types.CLEAR_COLLECTOR,
});

// ─── UPDATE COLLECTOR ACTIONS ────────────────────────────────────────────────────
//
export const UpdateCollector = (collector, id) => ({
  type: types.UPDATE_COLLECTOR,
  payload: {
    collector,
    id,
  },
});
export const UpdateCollectorSuccess = (response) => ({
  type: types.UPDATE_COLLECTOR_SUCCESS,
  payload: response,
});
export const UpdateCollectorFailed = (error) => ({
  type: types.UPDATE_COLLECTOR_FAILED,
  payload: error,
});
//

export const UpdateCollectorList = (collector, projectName) => ({
  type: types.UPDATE_COLLECTOR_LIST,
  payload: collector,
});

export const FetchACollectorConfigStats = (collector) => ({
  type: types.FETCH_A_COLLECTOR_CONFIG_STATS,
  payload: collector,
});

export const FetchACollectorConfigStatsSuccess = (response) => ({
  type: types.FETCH_A_COLLECTOR_CONFIG_STATS_SUCCESS,
  payload: response,
});

export const FetchACollectorConfigStatsFailed = (error) => ({
  type: types.FETCH_A_COLLECTOR_CONFIG_STATS_FAILED,
  payload: error,
});

export const ClearCollectorConfigStats = () => ({
  type: types.CLEAR_COLLECTOR_CONFIG_STATS,
});

export const UpdateLinkedCollector = (collector, projectName) => ({
  type: types.UPDATE_LINKED_COLLECTOR,
  payload: {
    collector,
    projectName,
  },
});
export const UpdateLinkedCollectorSuccess = (response) => ({
  type: types.UPDATE_LINKED_COLLECTOR_SUCCESS,
  payload: response,
});
export const UpdateLinkedCollectorFailed = (error) => ({
  type: types.UPDATE_LINKED_COLLECTOR_FAILED,
  payload: error,
});
//
// Fetch platform  actions
//
export const FetchPlatforms = (data) => ({
  type: types.FETCH_PLATFORMS,
  payload: data,
});

export const FetchPlatformsSuccess = (playerList) => ({
  type: types.FETCH_PLATFORMS_SUCCESS,
  payload: playerList,
});

export const FetchPlatformsFailed = (errorRsponse) => ({
  type: types.FETCH_PLATFORMS_FAILED,
  payload: errorRsponse,
});
//
// Fetch players actions
//
export const FetchMediaPlugins = (category) => ({
  type: types.FETCH_MEDIA_PLUGINS,
  payload: category,
});

export const FetchMediaPluginsSuccess = (playerList) => ({
  type: types.FETCH_MEDIA_PLUGINS_SUCCESS,
  payload: playerList,
});

export const FetchMediaPluginsFailed = (errorRsponse) => ({
  type: types.FETCH_MEDIA_PLUGINS_FAILED,
  payload: errorRsponse,
});

export const clearMediaPluginsList = () => ({
  type: types.CLEAR_MEDIA_PLUGINS_LIST,
});

//
// Crete players actions
//

export const CreateCollectorConfiguration = (params) => ({
  type: types.CREATE_COLLECTOR_CONFIGURATION,
  payload: params,
});

export const CreateCollectorConfigurationSuccess = (successResponse) => ({
  type: types.CREATE_COLLECTOR_CONFIGURATION_SUCCESS,
  payload: successResponse,
});

export const CreateCollectorConfigurationFailed = (errorRsponse) => ({
  type: types.CREATE_COLLECTOR_CONFIGURATION_FAILED,
  payload: errorRsponse,
});

export const ClearCollectorCreateResponse = () => ({
  type: types.CLEAR_COLLECTOR_CONFIGURATION_RESPONSE,
});

export const ClearCollectorList = () => ({
  type: types.CLEAR_COLLECTOR_LIST,
});

export const ClearJavascriptCollectorList = () => ({
  type: types.CLEAR_JAVASCRIPT_COLLECTOR_LIST,
});

export const LoadMoreJavascriptCollector = (
  companyId,
  page,
  size,
  order,
  field,
  filters,
) => ({
  type: types.LOAD_MORE_JAVASCRIPT_COLLECTORS,
  payload: {
    companyId,
    page,
    size,
    order,
    field,
    filters,
  },
});
export const LoadMoreJavascriptCollectorSuccess = /* istanbul ignore next */ (
  list,
) => ({
  type: types.LOAD_MORE_JAVASCRIPT_COLLECTORS_SUCCESS,
  payload: list,
});
export const LoadMoreJavascriptCollectorFailed = /* istanbul ignore next */ (
  error,
) => ({
  type: types.LOAD_MORE_JAVASCRIPT_COLLECTORS_FAILED,
  payload: error,
});
export const FetchCollectorLogs = (id) => ({
  type: types.FETCH_COLLECTOR_LOGS,
  payload: id,
});
export const FetchCollectorLogsSuccess = (logs) => ({
  type: types.FETCH_COLLECTOR_LOGS_SUCCESS,
  payload: logs,
});
export const FetchCollectorLogsFailed = (error) => ({
  type: types.FETCH_COLLECTOR_LOGS_FAILED,
  payload: error,
});
export const FetchACollectorAdFramework = (id) => ({
  type: types.FETCH_A_COLLECTOR_ADFRAMEWORK,
  payload: id,
});
export const FetchACollectorAdFrameworkSuccess = (response) => ({
  type: types.FETCH_A_COLLECTOR_ADFRAMEWORK_SUCCESS,
  payload: response,
});
export const FetchACollectorAdFrameworkFailed = (error) => ({
  type: types.FETCH_A_COLLECTOR_ADFRAMEWORK_FAILED,
  payload: error,
});
